import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@common/queryKeys";
import { EventPagesAPI } from "@api/apis";

export const useGetEventList = (code) => {
  return useQuery({
    queryKey: [QUERY_KEYS.EVENT.INDEX, code],
    queryFn: async () => {
      const body = {
        modes: "ViewSet",
        code: code,
      };
      const res = await EventPagesAPI(body);

      if (res.Code === "0000") {
        return res.Data?.Row || []; // 정상 데이터 반환
      } else {
        console.error(res?.message); // 에러 처리
      }
    },
    enabled: !!code,
    retry: 1, // 요청 실패 시 한 번만 재시도
  });
};
